import { render } from "./BuyHouseComponent.vue?vue&type=template&id=5449f946&ts=true"
import script from "./BuyHouseComponent?vue&type=script&lang=ts"
export * from "./BuyHouseComponent?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/atlantis/atlantis/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__